/* eslint-disable prefer-promise-reject-errors */
import config from 'src/config';
import { postRequest, putRequest } from 'src/utils/RequestUtil';

export const productSearchAPI = async function (data) {
    const url = `${config.baseUrl}product/search`;
    return postRequest({
        url,
        data: {
            ...data,
            sortBy: 'productName',  // or another timestamp field
            sortOrder: 1,  // ascending order
        },
    });
};

export const productCreateAPI = function (data) {
    const url = `${config.baseUrl}product`;
    return postRequest({
        url,
        data,
    });
};

export const productUpdateAPI = function ({
    productId,
    data,
}) {
    const url = `${config.baseUrl}product/${productId}`;
    return putRequest({
        url,
        data,
    });
};
